<section class="content head">
    <div class="content-wrapper">
      <iaud-audit-title [audit]="audit"></iaud-audit-title>
      <iaud-breadcrumb [breadcrumbList]="breadcrumbs"></iaud-breadcrumb>
      <mat-card class="add-finding">
        <mat-card-title>New Finding</mat-card-title>
        <iaud-finding-edit-form #editFormComponent
          [finding]="finding" 
          [isNew]="true"
          [maxDate]="audit.dueDate"
          (isValidChange)="toggleFormValidity($event)"
          (isFinishLaterValidChange)="toggleFinishLaterFormValidity($event)"
          ></iaud-finding-edit-form>
  
        <div class="add-finding__buttons">
          <button mat-raised-button class="right-margin" routerLink="/audit/{{auditId}}">Cancel</button>
          <button mat-raised-button
                  class="right-margin"
                  (click)="submitFinding(true)"
                  [disabled]="!isFinishLaterValid || (isNextLoading$ | async) || (isLaterLoading$ | async)">
            <mat-spinner *ngIf="isLaterLoading$ | async" [diameter]="25"></mat-spinner>
            Save and finish later
          </button>
          <button mat-raised-button
                  (click)="submitFinding(false)"
                  [color]="'accent'"
                  [disabled]="!isFormValid || (isNextLoading$ | async) || (isLaterLoading$ | async)">
            <mat-spinner *ngIf="isNextLoading$ | async" [diameter]="25"></mat-spinner>
            Add CAPA/EC
          </button>
        </div>
      </mat-card>
    </div>
  </section>
  